<template>
    <div>
        <h2 class="timelineHeader">Approval Timeline</h2>
        <table id="timelineTBL" class="dppTBL">
            <tr>
                <th style="width:15%;">DATE/TIME</th>
                <th style="width:15%;">USER</th>
                <th style="width:15%;">AUTHORITY</th>
                <th v-if="activityId == 1 || activityId == 2" style="width:15%;">PRICE</th>
                <th style="width:40%;">NOTES</th>
            </tr>
            <tr>
                <td>{{ submission.full_time_stamp }}</td>
                <td style="text-transform: uppercase;">{{ createdByFullName }}</td>
                <td v-if="requestedByFullName" style="text-transform: uppercase;">Requested By: {{ requestedByFullName }}</td>
                <td v-else>Submitted</td>
                <td v-if="activityId == 1 || activityId == 2">---</td>
                <td>{{ submission.add_details }}</td>
            </tr>
            <tr v-for="step in stepsData">
                <td>{{ step.timestamp }}</td>
                <td style="text-transform: uppercase;">{{ step.user_name }} ({{ step.sales_level }})</td>
                <td>{{ step.status_string }}</td>
                <td v-if="activityId == 1 || activityId == 2">{{ step.price }}</td>
                <td>{{ step.notes }}</td>
            </tr>
            <tr v-if="submission.pricing_denial">
                <td>{{ submission.erp_timestamp }}</td>
                <td style="text-transform: uppercase;">{{ erpFullName }}</td>
                <td v-if="submission.pricing_denial == 'a'">Entered Into ERP</td>
                <td v-else>Denied</td>
                <td v-if="activityId == 1 || activityId == 2">{{ submission.pricing_price }}</td>
                <td>{{ submission.pricing_notes }}</td>
            </tr>
        </table>
    </div>
</template>

<script>
export default {
    data() {
        return {
            activityId: null,
            createdByFullName: null,
            erpFullName: null,
            requestedByFullName: null
        }
    },
    props: ['stepsData', 'submission'],
    watch: {
        submission() {
            this.activityId = this.submission.activity.id;
            this.createdByFullName = this.submission.created_by_user.full_name;
            this.requestedByFullName = this.submission.requested_by_user?.full_name || null;

            if(this.submission.erp_user) {
                this.erpFullName = this.submission.erp_user.full_name;
            }
        }
    }
}
</script>

<style scoped>
    .timelineHeader {
        text-transform:none;
        font-family:'acumin-pro-condensed', Helvetica, Arial, sans-serif;
    }

    #timelineTBL tr td,
    #timelineTBL tr th {
        text-align: left;
        background: #fff;
    }

    .dppTBL {
        margin-top: 2rem;
        text-align: left !important;
        font-size: 0.8rem;
        width: 100%;
    }

    .dppTBL th {
        font-weight: bold;
        padding: 0rem 1rem 0.2rem 0rem;
        border-bottom: 1px solid #666;
    }

    .dppTBL td {
        padding: 1rem 1rem 1rem 0;
        background: #fff;
        border-bottom: dotted 1px #ccc;
    }

    .dppTBL tr:nth-child(2n):hover>td {
        background: #fff;
    }

    .dppTBL tr:hover>th,
    .dppTBL tr:hover>td {
        background: #fff;
    }
</style>